import React, { Component } from 'react';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Typography from '@material-ui/core/Typography';
import CardHeader from '@material-ui/core/CardHeader';
import CardActions from '@material-ui/core/CardActions';
import { ThumbUp, ThumbDown, ThumbsUpDown } from '@material-ui/icons';
import Divider from '@material-ui/core/Divider';
import Avatar from '@material-ui/core/Avatar';
import './feedbackCard.css';

class FeedbackCard extends Component {
  constructor(props) {
    super(props);
    this.id = props.feedback.id;
    this.feedback = props.feedback.feedback;
    this.feedbackKind = props.feedback.feedbackKind;
    this.feedbackUserName = props.feedback.feedbackUserName;
    this.userName = props.feedback.userName;
    this.submittedAt = props.feedback.submittedAt;
    this.avatar = props.feedback.avatar;
    this.avatarImgUrl = props.feedback.avatarImgUrl;
  }

  renderFeedbackKind = () => {
    if (this.feedbackKind === 'positive') {
      return <ThumbUp color="primary" className="feedbackKind" />;
    } else if (this.feedbackKind === 'negative') {
      return <ThumbDown color="error" className="feedbackKind" />;
    }
    return <ThumbsUpDown color="disabled" className="feedbackKind" />;
  };

  renderCardHeader = () => {
    if (this.feedbackUserName) {
      return (
        <CardHeader
          title={`@${this.feedbackUserName}`}
          subheader={this.submittedAt}
        />
      );
    }
    return <CardHeader subheader={this.submittedAt} />;
  };

  render() {
    return (
      <Card className="feedbackCard">
        {this.renderCardHeader()}
        <Divider light />
        <CardContent>
          <Typography variant="title" align="center">
            {this.feedback}
          </Typography>
        </CardContent>
        <CardActions className="cardActions">
          <Avatar src={this.avatarImgUrl} />
          <Typography> {this.userName}</Typography>
          {this.renderFeedbackKind()}
        </CardActions>
      </Card>
    );
  }
}

export default FeedbackCard;



// WEBPACK FOOTER //
// ./src/components/feedback/FeedbackCard.js